import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../../common/ToolIconRadioButtonSet';
import ObjectDrawingUIAction from '../../../actions/ui/ObjectDrawingUIAction';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../../reducers/app';
import { LineType, ShapeKind } from '../../../drawing/types';
import SelectableRectangleIconButton
from '../../common/SelectableIconButton/SelectableRectangleIconButton';

interface ObjectLineTypeTabPanelListRowProps {
  selected: number;
  lineType: LineType;
  shapeKind: ShapeKind;
  dispatch: Dispatch<Action>;
}

const buttonContainerStyle: React.CSSProperties = {
  width: '86px',
  height: '52px',
  marginLeft: '10px',
  marginRight: '10px',
};

const titleContainerStyle: React.CSSProperties = {
  width: '105px',
};

const titleStyle: React.CSSProperties = {
  width: '92px',
};

const ObjectLineTypeTabPanelListRow: React.SFC<
  ObjectLineTypeTabPanelListRowProps
> = React.memo((props) => {
  const { selected, lineType, shapeKind, dispatch } = props;

  const disableLineTypeNone = (
    shapeKind === ShapeKind.StraightLine || shapeKind === ShapeKind.AxisAlignedStraightLine
  );

  return (
    <SettingTabPanelListRow>
      <SettingTabPanelListRowImageTitle
        imgName="text_shape_linetype_01"
        containerStyle={titleContainerStyle}
        imageStyle={titleStyle} />
      <ToolIconRadioButtonSet style={{ justifyContent: 'center', width: '100%' }}>
        <SelectableRectangleIconButton
          title="実線"
          imagePath="images/setting-popup/line-type/btn_square_line_type_02"
          containerStyle={buttonContainerStyle}
          active={lineType === LineType.Solid}
          onClick={() => ObjectDrawingUIAction.setLineType(selected, LineType.Solid, dispatch)} />
        <SelectableRectangleIconButton
          title="破線"
          imagePath="images/setting-popup/line-type/btn_square_line_type_03"
          containerStyle={buttonContainerStyle}
          active={lineType === LineType.Dashed}
          onClick={() => ObjectDrawingUIAction.setLineType(selected, LineType.Dashed, dispatch)} />
        <SelectableRectangleIconButton
          title="なし"
          disabled={disableLineTypeNone}
          imagePath="images/setting-popup/line-type/btn_square_line_type_01"
          containerStyle={buttonContainerStyle}
          active={lineType === LineType.None}
          onClick={() => ObjectDrawingUIAction.setLineType(selected, LineType.None, dispatch)} />
      </ToolIconRadioButtonSet>
    </SettingTabPanelListRow>
  );
});

const mapStateToProps = (appStates: AppStates) => {
  const { selected, toolSettings } = appStates.ui.objectDrawing;
  return {
    selected,
    lineType: toolSettings[selected].lineType,
    shapeKind: toolSettings[selected].shapeKind,
  };
};

export default connect(mapStateToProps)(ObjectLineTypeTabPanelListRow);
